<template>
    <div style="height:auto; position:relative; min-height: 400px;" class="block w-full fs_dropzone mt-0 pt-0 px-0"
         ref="nodecontainer">
        <div style="display:none" id="manual-upload-trigger"></div>
        <vue2-dropzone ref="myDropzone"
                       class="p-0 border-0 border-transparent"
                       :options="dropzoneOptions"
                       :id="'dz-current'"
                       :duplicateCheck="false"
                       :includeStyling="false"
                       :useCustomSlot="true"
                       v-on:vdropzone-drag-enter="() => draggedOver(null)"
                       v-on:vdropzone-drag-over="() => draggedOver(null)"
                       v-on:vdropzone-drag-leave="() => draggedOut(null)"
                       v-on:vdropzone-success="success"
                       v-on:vdropzone-complete="() => draggedOut(null)"
        >
            <div class="sticky top-0 mx-0 my-0 px-1 py-1 md:px-4 md:py-2 z-20 bg-white border-gray-200 border-b"
                 ref="filterBar">
                <div class="flex items-center justify-between py-0">
                    <template v-if="foundNodes">
                        <div class="w-full flex-column hidden md:block">
                            <div class="flex-1">
                                Search :
                                <div
                                    class="inline-block cursor-pointer whitespace-nowrap font-semibold text-xs rounded-xl px-2 py-1.5 mx-0.5"
                                    :class="!searchWithin?'bg-gray-100 border border-gray-300 ':'hover:text-blue-500 hover:bg-gray-100 bg-white'"
                                    @click="() => {searchWithin = false; search()}">
                                    <span class="fas fa-home text-sm"
                                          style="margin-top:0px;margin-bottom:0px;margin-right:6px;"></span>All
                                </div>
                                <div v-if="searchFrom"
                                     class="inline-block cursor-pointer whitespace-nowrap font-semibold text-xs rounded-xl px-2 py-1.5 mx-0.5"
                                     :class="searchWithin?'bg-gray-100 border border-gray-300':'hover:text-blue-500 hover:bg-gray-100 bg-white'"
                                     @click="() => {searchWithin = true; search()}">
                                    {{ this.searchFrom.name }}
                                </div>
                            </div>
                            <!--
                            <div class="flex-1 mt-0.5">
                                <b class="inline-block min-w-0 transform overflow-hidden text-ellipsis whitespace-nowrap align-middle text-sm font-bold transition-all duration-200">
                                    Search results for "{{ this.searchValue }}"
                                </b>
                            </div>
                            -->
                        </div>
                    </template>
                    <div v-else class="relative flex text-left min-w-0 pr-3 pl-1 hidden md:inline-block truncate">
                        <template v-for="(node,index) in (this.breadcrumbs())">
                            <template v-if="node.isRoot">
                                <drop @drop="(e) => dropped(null,e)"
                                      class="cursor-pointer navlocation inline-block whitespace-nowrap text-sm font-bold hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1"
                                      @click="navigateTo(null)">
                                    <span class="fas fa-home text-sm"
                                          style="margin-top:4px;margin-bottom:4px;"></span>
                                </drop>
                                <div v-if="!node.isLast" class="inline-block p-0">&gt;</div>
                            </template>
                            <template v-else>
                                <drop @drop="(e) => dropped(node,e)"
                                      class="cursor-pointer navlocation inline-block whitespace-nowrap text-sm font-bold hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1"
                                      @click="navigateTo(node)">{{ node.name }}
                                </drop>
                                <div v-if="!node.isLast" class="inline-block p-0">&gt;</div>
                            </template>
                        </template>
                    </div>
                    <div class="flex items-center">
                        <div class="relative" v-if="selected.length">
                            <ui-dropdown menu-class="p-3 w-56">
                                <template #default="{ toggle }">
                                    <button title="Actions" @click="toggle"
                                            class="group w-[36px] py-1 cursor-pointer items-center justify-center items-center rounded-lg hover:bg-gray-100 hidden md:inline-flex">
                                        <div class="flex h-[28] items-center"><i
                                            class="fa fa-ellipsis-h text-gray-600"></i></div>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <fs-selected-context-menu :id="`selected-menu`"
                                                              :last-selected="lastSelected"
                                                              :rotations="rotations"
                                                              :selected="selected"
                                                              :non-system="nonSystem"
                                                              :can-show-info="canShowInfo"
                                                              :filesystem="filesystem"
                                                              :close-menus="close"
                                                              :delete-nodes="deleteNodes"
                                                              :enter-node-rename="enterNodeRename"
                                                              :download-node="downloadNode"
                                                              :download-nodes-as-zip="(nodes) => $emit('downloadNodesAsZip',nodes)"
                                                              :upload-revision="uploadRevision"
                                                              :prefs="prefs"
                                                              @setPrefs="setPrefs"
                                    >
                                    </fs-selected-context-menu>
                                </template>
                            </ui-dropdown>
                        </div>
                        <div class="relative" v-if="!foundNodes">
                            <ui-dropdown menu-class="p-3 w-48">
                                <template #default="{ toggle }">
                                    <button title="Create Something" @click="toggle"
                                            class="group inline-flex w-[48px] md:w-[36px] py-1 cursor-pointer items-center justify-center rounded-lg hover:bg-gray-100">
                                        <div
                                            class="flex h-[36] md:h-[28] items-center pl-5 pr-4 md:pl-0 md:pr-0 text-xl md:text-base">
                                            <i class="fa fa-plus text-gray-600"></i>
                                        </div>
                                    </button>
                                </template>
                                <template #menu="{ close }">
                                    <ui-dropdown-item icon="far fa-folder-open" @click="createNewFolder();close();">
                                        Create new Folder
                                    </ui-dropdown-item>
                                    <ui-dropdown-item icon="far fa-file" @click="manualUpload();close();">Upload File
                                    </ui-dropdown-item>
                                </template>
                            </ui-dropdown>
                        </div>
                        <div class="relative">
                            <fs-sort-view-menu :prefs="prefs" @setPrefs="setPrefs" :can-show-info="canShowInfo">
                            </fs-sort-view-menu>
                        </div>
                        <div class="relative cursor-pointer rounded-lg bg-gray-100 ml-3 mr-0 my-2 block">
                            <div class="flex w-64 items-center justify-between px-3 py-1 text-left xl:w-64">
                                <div class="flex items-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18px"
                                        height="18px"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="vue-feather text-gray-400 feather feather-search"
                                    >
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                    </svg>
                                    <page-cell name="search" v-model="searchValue" @input="search"
                                               @keydown.esc="searchValue=''; search()"
                                               placeholder="Search anything..."
                                               class="w-48 mx-1 py-1.5 px-1.5 text-xs font-bold text-gray-600 border-none border-transparent resize-none shadow-none outline-none ring-0 bg-transparent text-sm mb-0 w-fill">
                                    </page-cell>
                                    <span class="text-gray-500 fa fa-times pl-1 hover:text-blue-500" v-if="searchValue"
                                          @click="searchValue=''; search()"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex text-left min-w-0 pr-3 pl-1 md:hidden truncate">
                    <template v-if="foundNodes">
                        <b class="inline-block min-w-0 transform overflow-hidden text-ellipsis whitespace-nowrap align-middle text-sm font-bold transition-all duration-200">
                            Search results for "{{ this.searchValue }}"
                        </b>
                    </template>
                    <template v-else v-for="(node,index) in (this.breadcrumbs())">
                        <template v-if="node.isRoot">
                            <drop @drop="(e) => dropped(null,e)"
                                  class="cursor-pointer inline-block whitespace-nowrap text-sm font-bold hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1"
                                  @click="navigateTo(null)">
                                    <span class="fas fa-home text-sm"
                                          style="margin-top:4px;margin-bottom:4px;"></span>
                            </drop>
                            <div v-if="!node.isLast" class="inline-block p-0">&gt;</div>
                        </template>
                        <template v-else>
                            <drop @drop="(e) => dropped(node,e)"
                                  class="cursor-pointer inline-block whitespace-nowrap text-sm font-bold hover:text-blue-500 hover:bg-gray-100 rounded border-2 border-none px-1"
                                  @click="navigateTo(node)">{{ node.name }}
                            </drop>
                            <div v-if="!node.isLast" class="inline-block p-0">&gt;</div>
                        </template>
                    </template>
                </div>
            </div>
            <div :ref="'innercontainer'" class="flex flex-row w-full h-full"
                 @contextmenu.prevent.stop="(e) => openContext(null,e)"
                 @mousedown="closeMenus">
                <div tabindex="-1" class="w-full relative pl-3 pr-3" ref="nodes-container"
                     :style="(canShowInfo&&(prefs.showPreview)?'max-width:min(512px, calc(100% - 294px));':'')">
                    <div v-if="foundNodes && foundNodes.length===0">
                        <div class="flex h-full items-center justify-center p-12">
                            <div class="text-center">
                                <small class="block text-xs text-gray-500">
                                    No results found
                                </small>
                            </div>
                        </div>
                    </div>
                    <div v-if="!foundNodes && current.nodes.length===0" id="node-preview"
                         class="absolute top block w-full m-0"></div>
                    <div v-if="!foundNodes && current.nodes.length===0">
                        <div class="flex h-full items-center justify-center p-12">
                            <div class="text-center">
                                <small class="block text-xs text-gray-500">
                                    No files or directories
                                </small>
                            </div>
                        </div>
                    </div>
                    <fs-directory v-if="newDirectory"
                                  :directory="newDirectory"
                                  :data="{}"
                                  :filesystem="filesystem"
                                  @renameNode="renameNode"
                                  @cancelRenameNode="cancelRenameNode"
                                  :selected="selected"
                                  ref="newDirectory"
                                  :prefs="prefs"
                                  class="pt-1 pr-1.5"
                                  :class="prefs.size==='small'?'pl-1':'pl-2.5 pb-2'"
                    ></fs-directory>
                    <template v-for="nodeGroup in (foundNodes?foundNodes.groups:current.nodes.groups)">
                        <div class="relative pt-1" :key="'group-'+nodeGroup.id">
                            <div class="sticky top-[3.5rem] bg-white z-10" ref="groupTitle">
                                <div v-if="prefs.groupBy === 'tags'" class="pl-0 pt-1 pb-1"
                                     :class="prefs.size==='large'?'mb-1':''">
                                    <template v-if="nodeGroup.tags.length">
                                        <div class="inline-block" v-for="(tag, index) in nodeGroup.tags">
                                            <div class="w-2.5 h-2.5 inline-block rounded-full flex-0 mt-1"
                                                 :style="'border: 0.8px solid rgba(150, 150, 150, .3);  background-color: '+filesystem.tags.find((t) => t.name === tag).colorHex"></div>
                                            <div class="inline-block mr-1 text-xs font-bold">{{ tag }}</div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="inline-block mr-1 text-xs font-bold">Un-Tagged</div>
                                    </template>
                                </div>
                                <div v-else-if="prefs.groupBy === 'created' || prefs.groupBy === 'updated'"
                                     class="pl-0 pt-1 pb-1" :class="prefs.size==='large'?'mb-1':''">
                                    <div class="inline-block mr-1 text-xs font-bold">{{ nodeGroup.title }}</div>
                                </div>
                                <div v-else-if="prefs.groupBy === 'createdBy' || prefs.groupBy === 'updatedBy'"
                                     class="pl-0 pt-1 pb-1" :class="prefs.size==='large'?'mb-1':''">
                                    <div class="inline-block mr-1 text-xs font-bold">{{ nodeGroup.title }}</div>
                                </div>
                            </div>
                            <drag v-for="[node,data] in nodeGroup.nodes.map((i) => [i.node,i])" :data="node"
                                  :key="data.id"
                                  @dragstart="(e) => dragStart(node,e)"
                                  @dragend="(e) => dragEnd(node,e)"
                                  :disabled="!!foundNodes || mobile"
                                  @contextmenu.prevent="(e) => openContext(node,e)"
                            >
                                <template v-slot:drag-image="{data}">
                                    <div class="bg-white pt-1 pl-1.5 pr-1.5 rounded-xl border-2 border-transparent"
                                         :class="prefs.size==='small'?'pb-1.5':'pb-0'">
                                        <template v-for="node in nonSystem">
                                            <fs-file v-if="node.type==='file'"
                                                     :file="node"
                                                     :selected="nonSystem"
                                                     :prefs="prefs"
                                                     :rotations="rotations"
                                                     class="bg-blue-100"
                                                     :class="prefs.size === 'small' ? 'mb-0 py-0 pl-1 pr-1.5 ' : 'rounded-xl mb-1 border-2 px-2 py-2 border-transparent '"
                                                     :filesystem="filesystem"
                                            ></fs-file>
                                            <div v-else-if="node.type==='directory'" class="bg-blue-100"
                                                 :class="prefs.size === 'small' ? 'mb-0 py-0 pl-1 pr-1.5 ' : 'rounded-xl mb-1 border-2 px-2 py-2 border-transparent '">
                                                <fs-directory :directory="node"
                                                              :selected="nonSystem"
                                                              :prefs="prefs"
                                                              :filesystem="filesystem"
                                                ></fs-directory>
                                            </div>
                                        </template>
                                    </div>
                                </template>
                                <div v-if="node.type==='file'"
                                     @mousedown="(e) => selectDown(data, e)"
                                     @mouseup="(e) => selectUp(data, e)"
                                >
                                    <fs-file
                                        :file="node"
                                        :data="data"
                                        :filesystem="filesystem"
                                        :rotations="rotations"
                                        @selectDown="(data,e) => selectDown(data,e)"
                                        @selectUp="(data,e) => selectUp(data,e)"
                                        @renameNode="renameNode"
                                        @nextNode="nextNode"
                                        @previousNode="previousNode"
                                        @newSelection="(node) => {removeAllSelectedNodes(); addASelectedNode(node,false)}"
                                        :last-up="lastUp"
                                        :last-down="lastDown"
                                        :selected="selected"
                                        :current="foundNodes?foundNodes:current.nodes"
                                        :ref="data.id"
                                        :prefs="prefs"
                                        :inner-class="getClass(data)"
                                        @reload="$emit('reload')"
                                        @uploadingStarted="(e) => $emit('uploadingStarted',e)"
                                        @uploadingFinished="$emit('uploadingFinished')"
                                        :can-upload="canUpload"
                                    ></fs-file>
                                </div>
                                <drop v-else-if="node.type==='directory'" @drop="(e) => dropped(node,e)"
                                      @dblclick="() => navigateTo(node)"
                                      @mousedown="(e) => selectDown(data,e)"
                                      @mouseup="(e) => selectUp(data,e)"
                                      :accepts-data="(data) => accepts(data,node)"
                                      :disabled="!!foundNodes || mobile"
                                >
                                    <fs-directory
                                        :directory="node"
                                        :data="data"
                                        :filesystem="filesystem"
                                        @go="navigateTo"
                                        @renameNode="renameNode"
                                        @draggedOver="(e) => draggedOver(data)"
                                        @draggedOut="(e) => draggedOut(data)"
                                        @nextNode="nextNode"
                                        @previousNode="previousNode"
                                        :selected="selected"
                                        :last-up="lastUp"
                                        :last-down="lastDown"
                                        @selectDown="(data,e) => selectDown(data,e)"
                                        @selectUp="(data,e) => selectUp(data,e)"
                                        :inner-class="getClass(data)"
                                        :prefs="prefs"
                                        :ref="data.id"
                                        @reload="$emit('reload')"
                                        @uploadingStarted="(e) => $emit('uploadingStarted',e)"
                                        @uploadingFinished="$emit('uploadingFinished')"
                                        :can-upload="canUpload"
                                    ></fs-directory>
                                </drop>
                            </drag>
                            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right"
                                 v-if="filesToBeConfirmed.length || filesBeingProcessed.length || filesToBeProcessed.length">
                                {{ filesToBeProcessed.length + filesBeingProcessed.length }} remaining files to
                                upload
                                ({{ filesToBeConfirmed.length }} awaiting confirmation)
                            </div>
                            <div class="block w-full m-0 pr-3 overflow-hidden max-h-20 text-right text-red-600"
                                 v-if="filesErrored.length">
                                {{ filesErrored.length }} files failed to upload - contact support
                            </div>
                        </div>
                    </template>
                    <div v-if="current.nodes.length" id="node-preview" class="block w-full m-0"></div>
                </div>
                <div class="flex-1 border-gray-200 border-l p-0 m-0" ref="selected-panel-container" style="width:100%"
                     :class="!canShowInfo?'hidden':''">
                    <fs-selected-panel ref="selected-panel" :selected="selected"
                                       v-if="(prefs.showInfo || prefs.showPreview)"
                                       :last-moused-over="lastMousedOver?lastMousedOver.node:false"
                                       :filesystem="filesystem"
                                       :rotations="rotations"
                                       @closeContextMenus="closeMenus"
                                       @preview="preview"
                                       :prefs="prefs"
                                       @navigateTo="navigateTo" class="flex-1"
                    ></fs-selected-panel>
                </div>
                <vue-context ref="menu" class="fixed p-0 focus:outline-none focus:ring-0 z-30" :close-on-click="false"
                             :close-on-scroll="false">
                    <div id="menu" class="p-3 w-56 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                        <fs-selected-context-menu :selected="selected"
                                                  :last-selected="lastSelected"
                                                  :non-system="nonSystem"
                                                  :can-show-info="canShowInfo"
                                                  :filesystem="filesystem"
                                                  :close-menus="closeMenus"
                                                  :delete-nodes="deleteNodes"
                                                  :enter-node-rename="enterNodeRename"
                                                  :download-node="downloadNode"
                                                  :download-nodes-as-zip="(nodes) => $emit('downloadNodesAsZip',nodes)"
                                                  :upload-revision="uploadRevision"
                                                  :prefs="prefs"
                                                  :rotations="rotations"
                                                  @setPrefs="setPrefs"
                        >
                        </fs-selected-context-menu>
                    </div>
                </vue-context>
                <vue-context ref="menu2" class="fixed p-0 focus:outline-none focus:ring-0 z-30" :close-on-click="false"
                             :close-on-scroll="false">
                    <div id="menu2" class="p-3 w-48 z-30 bg-white rounded-lg border border-gray-300 shadow-lg">
                        <ui-dropdown-item icon="far fa-folder-open" @click="createNewFolder();closeMenus()">
                            Create new Folder
                        </ui-dropdown-item>
                        <ui-dropdown-item icon="far fa-file" @click="manualUpload();closeMenus()">Upload File
                        </ui-dropdown-item>
                    </div>
                </vue-context>
            </div>
        </vue2-dropzone>
    </div>
</template>

<script>
import FsSelectedContextMenu from "./FsSelectedContextMenu.vue";
import FsFile from "./FsFile.vue";
import FsDirectory from "./FsDirectory.vue";
import FsSelectedPanel from "./FsSelectedPanel.vue";
import {Drag, Drop} from "vue-easy-dnd";
import AutoresizableInput from "../ui/AutoresizableInput";
import PageCell from "../ui/PageCell.vue";
import VueContext from "../vue-context/src/js/vue-context";
import UiDropdownItem from "../ui/UiDropdownItem.vue";
import vue2Dropzone from "vue2-dropzone";
import {uuid} from "../../utils";
import {Fs} from '@models'
import './fs_dropzone.css';
import UiDropdownDivider from "../ui/UiDropdownDivider.vue";
import User from "../../services/User";
import filesystem from "../files/Filesystem.vue";

//Dropzone.autoDiscover = false;

export default {
    components: {
        FsSelectedContextMenu,
        UiDropdownDivider,
        vue2Dropzone,
        UiDropdownItem,
        PageCell, AutoresizableInput, FsSelectedPanel, FsDirectory, FsFile, Drag, Drop, VueContext
    },
    props: {
        filesystem: Object,
        current: Object,
        selected: Array,
        infoNode: Object,
        prefs: Object,
        canUpload: true,
        rotations: Object,
    },
    data() {
        return {
            mobile: window.innerWidth <= 830,
            nonSystem: [],
            currentDragTarget: null,
            searchValue: '',
            storedSearchValue: '',
            foundNodes: null,
            dragHandle: null,
            newDirectory: null,
            dropzoneOptions: {
                url: 'https://a',
                autoProcessQueue: false,
                timeout: 0,
                autoQueue: false,
                parallelUploads: 25,
                useFsAccessApi: false,
                clickable: '#manual-upload-trigger',
                maxFiles: null,
                maxFilesize: 5120,
                previewsContainer: '#node-preview',
                accepted: (e) => {
                },
            },
            lastSelected: false,
            lastMousedOver: null,
            lastUp: false,
            lastDown: false,
            mouseOverTimer: false,
            canShowInfo: true,
            lastAddedCount: -1,
            lastConfirmedCount: -1,
            filesToBeProcessed: [],
            filesBeingProcessed: [],
            filesToBeConfirmed: [],
            filesErrored: [],
            scrollTimer: false,
            menuOpen: false,
            shiftStart: false,
            shiftCurrent: false,
            dragStarted: false,
            waiting: false,
            collisionStrategy: null,
            searchFrom: null,
            searchWithin: false,
            progress: 0,
            zipId: null,
        }
    },
    watch: {
        current: {
            handler(newValue, oldValue) {
                this.$forceUpdate()
            },
            deep: true,
        },
        'rotations.key': {
            handler(a, b) {
                this.$forceUpdate()
            },
        },
        prefs: {
            handler(newValue, oldValue) {
                if (this.foundNodes) {
                    Fs.orderNodes(this.foundNodes, this.prefs)
                }
            },
            deep: true,
        }
    },
    methods: {
        backListener(e) {
            if (e.state && e.state.id) {
                this.navigateTo(this.filesystem.getNodeById(e.state.id), true, false);
            } else if (e.state && e.state.search) {
                this.searchValue = e.state.search
                this.search(false)
            } else {
                this.navigateTo(false, true, false);
            }
        },
        calcTopOffset() {
            return 260
        },
        preview(node, revision) {
            this.$refs[this.lastSelected.id][0].$refs.focusCatcher.focus()
            this.$refs[this.lastSelected.id][0].preview({}, revision)
        },
        uploadRevision(data) {
            this.$refs[data.id][0].uploadRevision()
        },
        setPrefs(prefs) {
            this.prefs = prefs
            this.$emit("setPrefs", this.prefs)
        },
        breadcrumbs() {
            let r = (node) => node.parent ? node.parent : null
            let result = [this.current];
            result[0].isLast = true;
            while (!result[0].isRoot) {
                result.unshift(r(result[0]));
                result[0].isLast = false;
            }
            return result
        },
        createNewFolder() {
            this.newDirectory = {
                type: 'directory',
                id: '',
                name: '',
                nodes: [],
            };
            this.$nextTick(() => {
                this.$refs.newDirectory.editable = true
                this.$refs.newDirectory.editName(new Event('created'))
            })
        },
        search(pushState = true) {
            if (pushState && this.searchValue) {
                if (this.storedSearchValue) {
                    history.replaceState({search: this.searchValue}, '')
                } else {
                    history.pushState({search: this.searchValue}, '')
                    if (!this.current.isRoot) {
                        this.searchFrom = this.current
                    }
                }
            } else {
                this.searchFrom = null;
            }
            this.selected.splice(0, this.selected.length)
            this.lastMousedOver = false
            if (this.searchValue) {
                if (this.searchWithin) {
                    this.foundNodes = this.filesystem.search(this.searchValue, this.searchFrom);
                } else {
                    this.foundNodes = this.filesystem.search(this.searchValue);
                }
            } else {
                this.foundNodes = null;
            }
            this.storedSearchValue = this.searchValue
        },
        mousedOver(data, e) {
            if (!data) {
                this.mouseOverTimer = setTimeout(() => {
                    this.lastMousedOver = false;
                }, 75)
            } else {
                clearTimeout(this.mouseOverTimer);
                this.lastMousedOver = data;
            }
        },
        getClass(data) {
            let base = this.prefs.size === 'small' ? 'mb-0 py-0 pl-1 pr-1.5 ' : 'rounded-xl mb-1 border-2 px-2 py-2 border-transparent '
            base += this.currentDragTarget === data ? 'bg-gray-100 ' : ''
            if (this.isNodeSelected(data.node, data.nodeGroup)) {
                base += 'bg-blue-100 hover:bg-blue-200 '
            } else {
                base += 'hover:bg-gray-100 '
            }
            let start = false;
            if (!data.previousNode || (data.previousNode.nodeGroup !== data.nodeGroup)) {
                start = true;
            } else if (!this.isNodeSelected(data.previousNode.node, data.previousNode.nodeGroup)) {
                start = data.previousNode.id !== (this.lastMousedOver ? this.lastMousedOver.id : false);
            }
            let end = false;
            if (!data.nextNode || (data.nextNode.nodeGroup !== data.nodeGroup)) {
                end = true;
            } else if (!this.isNodeSelected(data.nextNode.node, data.nextNode.nodeGroup)) {
                end = data.nextNode.id !== (this.lastMousedOver ? this.lastMousedOver.id : false);
            }
            base += (start ? 'rounded-t-lg ' : '') + (end ? 'rounded-b-lg ' : '')
            return base;
        },
        openContext(node, e) {
            e.stopPropagation();
            if (node === null) {
                this.$refs.menu.close()
                this.$refs.menu2.open(e)
            } else {
                if (!this.selected.includes(node)) {
                    this.selected.push(node);
                }
                this.$refs.menu2.close()
                if (this.canShowInfo || this.nonSystem.length) {
                    this.$refs.menu.open(e)
                } else {
                    this.$refs.menu.close()
                }
            }
            if (this.$refs["selected-panel"] && this.$refs["selected-panel"].$children[0]) {
                let infomenu = this.$refs["selected-panel"].$children[0].$refs['revisionmenu'];
                if (infomenu) {
                    infomenu.close()
                }
            }
            this.menuOpen = true
        },
        closeMenus(e) {
            if (!e || !this.$refs.menu.$el.contains(e.target)) {
                this.$refs.menu.close()
            }
            if (!e || !this.$refs.menu2.$el.contains(e.target)) {
                this.$refs.menu2.close()
            }
            if ((this.$refs["selected-panel"] && this.$refs["selected-panel"].$refs.file && this.$refs["selected-panel"].$refs.file.$refs.revisionmenu)) {
                if (!e || !this.$refs["selected-panel"].$refs.file.$refs.revisionmenu.$el.contains(e.target)) {
                    this.$refs["selected-panel"].$refs.file.$refs.revisionmenu.close()
                }
            }

            this.menuOpen = false;
        },
        navigateTo(destination, jumpTo = true, pushState = true) {
            if (pushState) {
                history.pushState({id: (destination ? destination.id : null)}, '')
            }
            this.foundNodes = null
            this.searchValue = ''
            this.storedSearchValue = false
            this.lastMousedOver = false
            this.$emit('navigateTo', destination, jumpTo,)
        },
        draggedOver(data) {
            this.currentDragTarget = data;
        },
        draggedOut(data) {
            this.currentDragTarget = null;
        },
        dragStart(node, e) {
            this.dragStarted = true;
        },
        dragEnd(node, e) {
            this.dragHandle = node;
        },
        selectUp(data, e) {
            const node = data.node
            const nodeGroup = data.nodeGroup

            if (this.$refs[data.id] && this.$refs[data.id][0].editingName) {
                this.dragStarted = false;
                return;
            }
            this.lastDown = node;
            if (this.isNodeSelected(node, nodeGroup) && this.dragStarted === false && e.button === 0) {
                if (!e.ctrlKey && !e.shiftKey && !e.metaKey) {
                    this.removeAllSelectedNodes()
                    this.addASelectedNode(node, nodeGroup);
                }
            }
            this.dragStarted = false;
            if (this.selected.includes(this.dragHandle)) {
                this.dragHandle = null
            }
        },
        addASelectedNode(node, nodeGroup) {
            if (!this.selected.includes(node)) {
                this.selected.push(node);
            }
            if (nodeGroup === false) {
                nodeGroup = this.current.nodes.groups.find((hh) => hh.id === node.groupId)
            }
            if (nodeGroup) {
                if (!node.selectedGroups.includes(nodeGroup.title)) {
                    node.selectedGroups.push(nodeGroup.title)
                }
            }
        },
        removeASelectedNode(node, nodeGroup) {
            if (node.selectedGroups.includes(nodeGroup.title)) {
                node.selectedGroups.splice(node.selectedGroups.indexOf(nodeGroup.title), 1);
            }
            if (node.selectedGroups.length === 0) {
                this.selected.splice(this.selected.indexOf(node), 1);
            }
        },
        removeAllSelectedNodes() {
            this.selected.forEach((n) => n.selectedGroups.splice(0, n.selectedGroups.length))
            this.selected.splice(0, this.selected.length);
        },
        isNodeSelected(node, nodeGroup) {
            return this.selected.includes(node) && this.selected.find((i) => i.id == node.id).selectedGroups.includes(nodeGroup.title)
        },
        selectDown(data, e) {
            const node = data.node
            const nodeGroup = data.nodeGroup
            if (this.$refs[data.id] && this.$refs[data.id][0].editingName) {
                return;
            }
            this.shiftStart = false;
            this.shiftCurrent = false;
            this.closeMenus(e);
            this.lastUp = node;
            if (e) {
                if (e.shiftKey) {
                    if (data.order > this.lastSelected.order) {
                        let node = this.lastSelected
                        while (node.nextNode && node.id !== data.id) {
                            this.addASelectedNode(node.node, node.nodeGroup)
                            node = node.nextNode
                        }
                    } else {
                        let node = data
                        while (node.nextNode && node.id !== this.lastSelected.id) {
                            this.addASelectedNode(node.node, node.nodeGroup)
                            node = node.nextNode
                        }
                    }
                    this.addASelectedNode(data.node, data.nodeGroup)
                } else {
                    if (!this.isNodeSelected(node, nodeGroup)) {
                        if (e.ctrlKey || e.metaKey || this.selected.length === 0) {
                            this.addASelectedNode(node, nodeGroup)
                        } else {
                            this.removeAllSelectedNodes()
                            this.addASelectedNode(node, nodeGroup)
                        }
                    } else {
                        let remove = false;
                        if (e.metaKey) {
                            remove = true;
                        } else if (e.ctrlKey) {
                            if (navigator.userAgent.indexOf('Mac OS X') === -1) {
                                remove = true
                            }
                        }
                        if (remove) {
                            this.removeASelectedNode(node, nodeGroup)
                        }
                    }
                }
            }
            this.lastSelected = data
            // Set the focus
            window.setTimeout(() => {
                if (this.$refs[data.id] && this.$refs[data.id][0]) {
                    this.$refs[data.id][0].$refs.focusCatcher.focus()
                }
            }, 1);
            this.lastMousedOver = data
            this.selected.sort((a, b) => a.order - b.order)
            this.nonSystem = this.selected.filter((i) => !i.system)
            document.dispatchEvent(new Event('mousedown'));
            this.$forceUpdate();
        },
        async dropped(node) {
            try {
                await this.filesystem.moveNodes(this.nonSystem, node)
            } catch (e) {
                this.$modals.error({
                    title: 'Duplicate name error',
                    paragraphs: ['Cannot move selected files/folders', '', 'The following message was received from the server :', e.message],
                })
            }
            let newNode = this.filesystem.getNodeById(this.current.id)
            this.navigateTo(newNode ? newNode : null)
        },
        async confirmDeleteMultiNodes(nodes) {
            let title = `Delete ${nodes.length} selected files and folders including all sub-folders, files inside the folders and any file revisions?`
            if (nodes.every((i) => i.type === 'file')) {
                title = `Delete ${nodes.length} files including any file revisions?`
            }
            if (nodes.every((i) => i.type === 'directory')) {
                title = `Delete ${nodes.length} folders including all sub-folders and any files inside the folders?`
            }
            this.$modals.confirmDelete({
                title: title,
                button: 'Yes, delete all',
                handle: async () => {
                    await this.filesystem.deleteNodes(nodes)
                    let newNode = this.filesystem.getNodeById(this.current.id)
                    this.navigateTo(newNode ? newNode : null, false)
                }
            })
        },
        async confirmDeleteNode(node) {
            let button = 'Yes, delete file'
            let title = `Delete "${node.name}" including any file revisions?`
            if (node.type === 'folder') {
                button = 'Yes, delete folder'
                title = `Delete "${node.name}" including all sub-folders and any files inside the folders?`
            }
            this.$modals.confirmDelete({
                title: title,
                button: button,
                handle: async () => {
                    await this.filesystem.deleteNodes([node])
                    let newNode = this.filesystem.getNodeById(this.current.id)
                    this.navigateTo(newNode ? newNode : null, false)
                }
            })
        },
        enterNodeRename(data) {
            this.$refs[data.id][0].editable = true
            this.$refs[data.id][0].editName(false)
        },
        async deleteNodes(nodes) {
            this.$modals.close()
            setTimeout(async () => {
                if (nodes.length === 1) {
                    await this.confirmDeleteNode(nodes[0])
                } else {
                    await this.confirmDeleteMultiNodes(nodes)
                }
            }, 50)
        },
        async renameNode(node, newName) {
            if (!node.id) {
                try {
                    await this.filesystem.createDirectory(newName, this.current);
                } catch (e) {
                    this.$modals.error({
                        title: 'Duplicate name error',
                        paragraphs: ['Cannot create directory "' + newName + '"', '', 'The following message was received from the server :', e.message],
                    })
                }
                this.newDirectory = null;
                let newNode = this.filesystem.getNodeById(this.current.id)
                this.navigateTo(newNode ? newNode : null)
            } else {
                try {
                    await this.filesystem.updateNodeName(node, newName);
                } catch (e) {
                    this.$modals.error({
                        title: 'Duplicate name error',
                        paragraphs: ['Cannot rename "' + node.name + '" to "' + newName + '"', '', 'The following message was received from the server :', e.message],
                    })
                }
            }
        },
        cancelRenameNode(node) {
            if (node.id === '') {
                this.newDirectory = null;
            }
        },
        accepts(data, node) {
            return (this.nonSystem.length > 0) && !this.selected.includes(node);
        },
        downloadNode(node) {
            let a = document.createElement("a")
            document.body.appendChild(a)
            a.style = "display: none"
            a.href = this.getNodeUrl(node) + '?forceDownload=1';
            a.download = "download"
            a.click();
            document.body.removeChild(a)
        },
        getNodeUrl(node) {
            if (!node.node.supportsRotations) {
                return node.node.url
            }
            let rot = this.rotations[node.node.id];
            if (!rot) {
                return node.node.url
            }
            return node.node.rotations[rot] ? node.node.rotations[rot].url : node.node.url
        },
        manualUpload(node) {
            this.$refs.myDropzone.$el.dropzone.clickableElements[0].click();
        },
        async triggerNewFiles(files) {
            this.intentUpdateInProgress = true;
            files.forEach((i) => {
                i.id = uuid()
            })
            this.filesBeingProcessed.push(...files);
            await this.filesystem.createUploadIntent(files.map(i => {
                return {
                    id: i.id,
                    size: i.size,
                    name: i.name,
                    relativePath: i.fullPath ? i.fullPath.slice(0, 0 - i.name.length) : '/',
                    mimeType: i.type ? i.type : 'application/octet-stream'
                }
            }), this.current.isRoot ? null : this.current.id).then((value) => {
                if (!value) {
                    console.log('Upload-Intent creation failed!')
                    files.forEach((i, key) => {
                        this.$refs.myDropzone.$el.dropzone.removeFile(i);
                        this.filesBeingProcessed.splice(this.filesToBeProcessed.indexOf(i), 1);
                        this.filesErrored.push(1);
                    })
                    return;
                }
                files.forEach((i) => {
                    i.uploadTarget = value.files.find((i2) => i2.id === i.id);
                    i.uploadConfirmation = {
                        'uploadIntentId': value.id,
                        'uploadFileId': i.uploadTarget.id,
                    }
                    i.previewElement.classList.remove('hidden')
                })
                files.forEach((i, key) => {
                    this.$refs.myDropzone.$el.dropzone.enqueueFile(i);
                })
                this.intentUpdateInProgress = false;
                this.$refs.myDropzone.processQueue();
            })
        },
        filesAdded() {
            this.$emit('uploadingStarted', this.current.id)
            if (this.addedTimer) {
                clearTimeout(this.addedTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeProcessed.length === 0) {
                    this.lastAddedCount = -1;
                    return;
//                } else if (this.filesToBeProcessed.length > 1) {
//                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, 1))
                } else if (this.filesToBeProcessed.length === this.lastAddedCount) {
                    this.triggerNewFiles(this.filesToBeProcessed.splice(0, this.filesToBeProcessed.length))
                }
            }
            this.lastAddedCount = this.filesToBeProcessed.length;
            this.addedTimer = setTimeout(() => {
                this.filesAdded()
            }, 250);
        },
        async triggerConfirmation(files, collisionStrategy = null) {
            this.intentUpdateInProgress = true;
            let postProcess = async () => {
                this.intentUpdateInProgress = false;
                files.forEach((i, key) => {
                    setTimeout(() => {
                        this.$refs.myDropzone ? this.$refs.myDropzone.$el.dropzone.removeFile(i) : null
                    }, 120);
                })
                if (this.filesToBeConfirmed.length + this.filesToBeProcessed.length + this.filesBeingProcessed.length === 0) {
                    this.collisionStrategy = null;
                    let newFs = await Fs.find(this.filesystem.id)
                    this.filesystem.nodes.splice(0, this.filesystem.nodes.length, ...newFs.nodes)
                    if (this.current.isRoot) {
                        this.navigateTo(null)
                    } else {
                        let newNode = this.filesystem.getNodeById(this.current.id)
                        this.navigateTo(newNode ? newNode : null)
                        this.$emit('uploadingFinished')
                    }
                }
            }
            await this.filesystem.confirmUploads(files.map(i => i.uploadConfirmation), collisionStrategy)
                .catch((e) => {
                    if (this.collisionStrategy) {
                        this.triggerConfirmation(files, this.collisionStrategy);
                    } else {
                        this.$modals.confirm({
                            title: 'Duplicate file name(s) detected',
                            paragraphs: ['One or more files being uploaded already exist in the current filesystem. Do you want to skip duplicates OR add the duplicate files?'],
                            button: 'Skip Duplicates',
                            button2: 'Add as Revisions',
                            button3: 'Add as new Files',
                            handle: async () => {
                                this.collisionStrategy = 'skip'
                                await this.triggerConfirmation(files, 'skip')
                            },
                            handle2: async () => {
                                this.collisionStrategy = 'revise'
                                await this.triggerConfirmation(files, 'revise')
                            },
                            handle3: async () => {
                                this.collisionStrategy = 'rename'
                                await this.triggerConfirmation(files, 'rename')
                            },
                            afterClose: async () => {
                                this.collisionStrategy = null
                                await postProcess()
                            }
                        })
                    }
                })
                .then(async (result) => {
                    if (!result) return;
                    await postProcess();
                })
        },
        success(file) {
            this.filesBeingProcessed.splice(this.filesBeingProcessed.indexOf(file), 1);
            this.filesToBeConfirmed.push(file)
            this.filesconfirmed()
            file.previewElement.classList.add('dz-shrink')
        },
        filesconfirmed() {
            if (this.successTimer) {
                clearTimeout(this.successTimer)
            }
            if (!this.intentUpdateInProgress) {
                if (this.filesToBeConfirmed.length === 0) {
                    this.lastConfirmedCount = -1;
                    return;
                } else if (this.filesToBeConfirmed.length > 200) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, 200), this.collisionStrategy)
                } else if (this.filesToBeConfirmed.length === this.lastConfirmedCount) {
                    this.triggerConfirmation(this.filesToBeConfirmed.splice(0, this.filesToBeConfirmed.length), this.collisionStrategy)
                }
            }
            this.lastConfirmedCount = this.filesToBeConfirmed.length;
            this.successTimer = setTimeout(() => {
                this.filesconfirmed()
            }, 250);
        },
        nextNode(e) {
            if (this.lastSelected) {
                if (this.lastSelected.nextNode) {
                    if (e.shiftKey) {
                        this.shiftStart = this.shiftStart ? this.shiftStart : this.lastSelected
                        if (this.shiftStart.order < this.lastSelected.nextNode.order) {
                            let findNext = (i) => {
                                if (this.isNodeSelected(i.node, i.nodeGroup)) {
                                    return i.nextNode ? findNext(i.nextNode) : false;
                                }
                                return i
                            }
                            let nextItem = findNext(this.lastSelected.nextNode);
                            this.addASelectedNode(nextItem.node, nextItem.nodeGroup)
                            this.lastSelected = nextItem;
                            this.lastMousedOver = this.lastSelected
                        } else {
                            this.removeASelectedNode(this.lastSelected.node, this.lastSelected.nodeGroup)
                            this.lastSelected = this.lastSelected.nextNode
                            this.lastMousedOver = this.lastSelected
                        }
                    } else {
                        this.shiftStart = false
                        if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
                            this.removeAllSelectedNodes()
                        }
                        this.addASelectedNode(this.lastSelected.nextNode.node, this.lastSelected.nextNode.nodeGroup)
                        this.lastSelected = this.lastSelected.nextNode
                        this.lastMousedOver = this.lastSelected
                    }
                }
                this.$refs[this.lastSelected.id][0].$refs.focusCatcher.focus()
            }
        },
        previousNode(e) {
            if (this.lastSelected) {
                if (this.lastSelected.previousNode) {
                    if (e.shiftKey) {
                        this.shiftStart = this.shiftStart ? this.shiftStart : this.lastSelected
                        if (this.shiftStart.order > this.lastSelected.previousNode.order) {
                            let findPrevious = (i) => {
                                if (this.isNodeSelected(i.node, i.nodeGroup)) {
                                    return i.previousNode ? findPrevious(i.previousNode) : false;
                                }
                                return i
                            }
                            let previousItem = findPrevious(this.lastSelected.previousNode);
                            this.addASelectedNode(previousItem.node, previousItem.nodeGroup)
                            this.lastSelected = previousItem;
                            this.lastMousedOver = this.lastSelected
                        } else {
                            this.removeASelectedNode(this.lastSelected.node, this.lastSelected.nodeGroup)
                            this.lastSelected = this.lastSelected.previousNode
                            this.lastMousedOver = this.lastSelected
                        }
                    } else {
                        this.shiftStart = false
                        if (!e.shiftKey && !e.ctrlKey && !e.metaKey) {
                            this.removeAllSelectedNodes()
                        }
                        this.addASelectedNode(this.lastSelected.previousNode.node, this.lastSelected.previousNode.nodeGroup)
                        this.lastSelected = this.lastSelected.previousNode
                        this.lastMousedOver = this.lastSelected
                    }
                }
                this.$refs[this.lastSelected.id][0].$refs.focusCatcher.focus()
            }
        },
        resize() {
            if (this.$refs.nodecontainer) {
                let maxHeight = this.$el.parentElement.parentNode.parentNode.getBoundingClientRect().height - 140
                if (this.$el.parentElement.parentNode.parentNode.getAttribute('id') == 'app-content') {
                    maxHeight = window.innerHeight - this.$refs.nodecontainer.getBoundingClientRect().top - 110
                }
                this.$refs.nodecontainer.setAttribute('style', 'min-height:' + Math.floor(maxHeight) + 'px')
                this.$refs.innercontainer.setAttribute('style', 'min-height:' + Math.floor(maxHeight - 180) + 'px')
            }
            this.mobile = window.innerWidth <= 830;
        },
    },
    updated() {
        this.resize()
    },
    mounted() {
        let scrollDebouncer = (e) => {
            if (!this.$refs.filterBar) {
                document.removeEventListener('scroll', scrollDebouncer)
                window.removeEventListener('resize', resize)
                return
            }
            let filterBar = this.$refs.filterBar.getBoundingClientRect()
            this.$refs.groupTitle.forEach((e) => {
                e.setAttribute('style', 'top:' + filterBar.height + 'px !important')
            })
            if (this.menuOpen) {
                let m = (target) => {
                    if (Math.abs(this.lastScrollTop - e.target.scrollTop) > 2) {
                        clearTimeout(this.scrollTimer)
                        this.scrollTimer = false;
                        if (this.menuOpen) {
                            this.closeMenus(e)
                        }
                    }
                }
                if (!this.scrollTimer) {
                    this.lastScrollTop = e.target.scrollTop;
                }
                this.scrollTimer = setTimeout(() => m(e.target), 20)
            } else {
                this.lastScrollTop = e.target.scrollTop;
                if (this.scrollTimer) {
                    clearTimeout(this.scrollTimer)
                    this.scrollTimer = false
                }
            }
        }

        this.resize()
        window.addEventListener('resize', this.resize, true);
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', this.resize)
        })

        document.addEventListener('scroll', scrollDebouncer, true);
        this.$on('hook:beforeDestroy', () => {
            document.removeEventListener('scroll', scrollDebouncer)
        })
        let resize = () => {
            this.canShowInfo = window.innerWidth > 640;
        }
        resize()
        window.addEventListener('resize', resize, true);
        this.$on('hook:beforeDestroy', () => {
            window.removeEventListener('resize', resize)
        })

        let that = this;
        this.$refs.myDropzone.$el.dropzone.on('addedfile', function (file) {
            if (that.canUpload !== true && (that.canUpload !== that.current.id)) {
                this.removeFile(file)
                return;
            }
            file.previewElement.classList.add('hidden')
            that.filesToBeProcessed.push(file)
            that.filesAdded()
        });
        this.$refs.myDropzone.$el.dropzone.on('sending', function (file, xhr, formData) {
            xhr.open('POST', file.uploadTarget.url);
            Object.entries(file.uploadTarget.inputs).forEach(entry => {
                const [key, value] = entry;
                formData.append(key, value);
            });
        });
        window.addEventListener("popstate", this.backListener);
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.backListener);
    }
}
</script>
<style>
.drop-in.drop-allowed div.dir {
    background-color: rgb(243 244 246) !important;
}

.drop-in.drop-allowed.navlocation {
    background-color: rgb(243 244 246) !important;
}
</style>
